import { render, staticRenderFns } from "./OfferForbidden.html?vue&type=template&id=52d900ad&"
import script from "./OfferForbidden.js?vue&type=script&lang=js&"
export * from "./OfferForbidden.js?vue&type=script&lang=js&"
import style0 from "./OfferForbidden.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports